const SobreporFotoBox = () => {
    return (
        <iframe
            src="/sobrepor-foto.html"
            style={{ width: "100%", height: "100vh", border: "none" }}
            title="Sobrepor Foto — Leve Saúde 6 Anos"
        />
    );
};

export default SobreporFotoBox;
